import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'comp-disclaimer-widget',
  templateUrl: './disclaimer-widget.component.html',
  styleUrls: ['./disclaimer-widget.component.scss'],
  imports: [TranslateModule],
})
export class DisclaimerWidgetComponent {
  readonly text = input<string | undefined>();
  readonly isLessImportant = input<boolean>(false);
  readonly alignment = input<'left' | 'center' | 'right'>('center');
}
